import { formatMinsToSeconds } from 'utils/formatting/dates'

export function segsToSegsOrMinsLiteral(seconds) {
  const secsOrMinsiteral = seconds >= 60 ? 'min' : 'segs'
  const duration = seconds >= 60 ? formatMinsToSeconds(seconds) : seconds
  return `${duration} ${secsOrMinsiteral}`
}
